import { useSelector } from 'react-redux'

import { useGetNewYearCustomMessages as useGetNewYearCustomMessagesShared } from '@lyrahealth-inc/shared-app-logic/src/features/CMSMicrosite/hooks/useGetNewYearCustomMessages'

import { getIsCustomerHPIExclusive, getNumberOfSessions } from '../../../data/customer/customerSelectors'

export const useGetNewYearCustomMessages = () => {
  const numSessions = useSelector(getNumberOfSessions)
  const isHPIExclusive = useSelector(getIsCustomerHPIExclusive)

  return useGetNewYearCustomMessagesShared({ numSessions, isHPIExclusive })
}
